var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.$store.state.data.allProjectsLoaded &&
    _vm.$store.state.data.allPagesLoaded &&
    _vm.$store.state.data.allServicesLoaded &&
    _vm.$store.state.data.allBnaLoaded
  )?_c('div',{attrs:{"id":"app"}},[_c('Nav',{attrs:{"navLinks":_vm.navLinks}}),_c('main',{class:("page-" + (_vm.$route.name))},[_c('router-view')],1),_c('Footer',{attrs:{"navLinks":_vm.navLinks}}),_c('div',{ref:"transBlock",staticClass:"trans-block"})],1):_c('div',[_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }